import React from "react";

const FLYERS = [
  { emoji: "🛸", top: "6%",  dur: "18s", delay: "0s",   dir: "right" },
  { emoji: "🚀", top: "20%", dur: "12s", delay: "3s",   dir: "left"  },
  { emoji: "🚁", top: "36%", dur: "22s", delay: "1s",   dir: "right" },
  { emoji: "👾", top: "52%", dur: "14s", delay: "6s",   dir: "left"  },
  { emoji: "🛸", top: "68%", dur: "20s", delay: "9s",   dir: "right" },
  { emoji: "🚀", top: "83%", dur: "11s", delay: "4s",   dir: "left"  },
  { emoji: "🚁", top: "13%", dur: "26s", delay: "11s",  dir: "left"  },
  { emoji: "👽", top: "44%", dur: "16s", delay: "7s",   dir: "right" },
  { emoji: "🛸", top: "76%", dur: "13s", delay: "2s",   dir: "left"  },
  { emoji: "👾", top: "29%", dur: "19s", delay: "14s",  dir: "right" },
];

const FLOATERS = [
  { emoji: "👾", left: "5%",  top: "32%", dur: "5s",   delay: "0s"   },
  { emoji: "👽", left: "91%", top: "22%", dur: "6.5s", delay: "1.5s" },
  { emoji: "🤖", left: "47%", top: "77%", dur: "4.5s", delay: "0.8s" },
  { emoji: "✨", left: "76%", top: "10%", dur: "3.5s", delay: "2s"   },
  { emoji: "👾", left: "22%", top: "87%", dur: "5.5s", delay: "1s"   },
  { emoji: "💥", left: "63%", top: "53%", dur: "4s",   delay: "3s"   },
];

// A3 Ice Blue firework colors: primary / secondary / tertiary
const FW_COLORS = ["#00b4ff", "#ffffff", "#00ffea"];

const FWORKS = [
  { left: "14%", top: "17%", colorIdx: 0, dur: "4s",   delay: "0s"   },
  { left: "77%", top: "11%", colorIdx: 1, dur: "5.5s", delay: "1.8s" },
  { left: "41%", top: "50%", colorIdx: 2, dur: "6s",   delay: "3.2s" },
  { left: "87%", top: "66%", colorIdx: 0, dur: "4.5s", delay: "0.8s" },
  { left: "9%",  top: "71%", colorIdx: 1, dur: "7s",   delay: "4.2s" },
  { left: "57%", top: "28%", colorIdx: 2, dur: "5s",   delay: "2.5s" },
  { left: "32%", top: "84%", colorIdx: 0, dur: "6.5s", delay: "1.2s" },
];

export default function SiteBackground() {
  return (
    <>
      {/* Solid bg + scanline grid — covers body background, sits at z-index 0 */}
      <div className="site-bg-layer" />

      {/* Animation layer — z-index 1, pointer-events: none */}
      <div className="site-anim-layer">
        {FLYERS.map((f, i) => (
          <div
            key={`fly${i}`}
            className={`site-fly site-fly--${f.dir}`}
            style={{
              top: f.top,
              animationDuration: f.dur,
              animationDelay: f.delay,
            }}
          >
            {f.emoji}
          </div>
        ))}

        {FLOATERS.map((f, i) => (
          <div
            key={`bob${i}`}
            className="site-bob"
            style={{
              left: f.left,
              top: f.top,
              animationDuration: f.dur,
              animationDelay: f.delay,
            }}
          >
            {f.emoji}
          </div>
        ))}

        {FWORKS.map((fw, i) => {
          const color = FW_COLORS[fw.colorIdx];
          const innerDelay = `${parseFloat(fw.delay) + 0.18}s`;
          return (
            <div
              key={`fw${i}`}
              className="site-fw"
              style={{ left: fw.left, top: fw.top }}
            >
              <div
                className="site-fw-ring"
                style={{
                  borderColor: color,
                  boxShadow: `0 0 8px ${color}`,
                  animationDuration: fw.dur,
                  animationDelay: fw.delay,
                }}
              />
              <div
                className="site-fw-ring site-fw-ring--inner"
                style={{
                  borderColor: color,
                  animationDuration: fw.dur,
                  animationDelay: innerDelay,
                }}
              />
              {[0, 1, 2, 3, 4, 5, 6, 7].map((si) => (
                <div
                  key={si}
                  className={`site-fw-spark site-fw-spark--${si}`}
                  style={{
                    background: color,
                    boxShadow: `0 0 6px ${color}`,
                    animationDuration: fw.dur,
                    animationDelay: fw.delay,
                  }}
                />
              ))}
            </div>
          );
        })}
      </div>
    </>
  );
}
